"use strict";

exports.__esModule = true;
exports.default = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireDefault(require("react"));

var _composeEventHandlers = _interopRequireDefault(require("../utils/composeEventHandlers"));

var _Dropdown = _interopRequireDefault(require("../Dropdown"));

var _IconArrowDropdownDown = _interopRequireDefault(require("../Icon/IconArrowDropdownDown"));

var _Menu = require("../Menu");

var _NavItem = _interopRequireDefault(require("./NavItem"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var getDropdownData = function getDropdownData(_ref) {
  var data = _ref.data,
      onClick = _ref.onClick,
      startingIndex = _ref.startingIndex;
  return data.map(function (_ref2, index) {
    var disabled = _ref2.disabled,
        icon = _ref2.icon,
        itemOnClick = _ref2.onClick,
        item = _objectWithoutPropertiesLoose(_ref2, ["disabled", "icon", "onClick"]);

    return _objectSpread({}, item, {
      disabled: disabled,
      iconStart: icon
    }, !disabled ? {
      onClick: (0, _composeEventHandlers.default)(itemOnClick, function (event) {
        onClick(event, startingIndex + index);
      })
    } : undefined);
  });
}; // eslint-disable-next-line react/display-name


var getDropdownItem = function getDropdownItem(itemAs) {
  return function (props) {
    var common = {
      /*
       * MenuItem strips `onClick` from  disabled items, so we can't render an `a`
       * with an `href` and then preventDefault (like we do for items directly in
       * Navigation). Instead, we force a `span` element.
       */
      as: itemAs === NavOverflowMenu.defaultProps.itemAs && props && props.props && props.props.disabled ? 'span' : itemAs,
      role: null,
      tabIndex: -1
    };
    var itemProps = props ? _objectSpread({}, props.props, common) : common;
    return (0, _core.jsx)(_Menu.MenuItem, itemProps);
  };
};

var _ref3 =
/*#__PURE__*/
(0, _core.jsx)(_IconArrowDropdownDown.default, null);

var NavOverflowMenu = function NavOverflowMenu(props) {
  var data = props.data,
      index = props.index,
      itemAs = props.itemAs,
      onClick = props.onClick,
      prefix = props.prefix,
      messages = props.messages,
      type = props.type;
  var rootProps = {
    data: getDropdownData({
      data: data,
      onClick: onClick,
      startingIndex: index
    }),
    item: getDropdownItem(itemAs)
  };
  var triggerProps = {
    'aria-label': messages.moreLabel,
    children: messages.moreText,
    as: 'button',
    iconEnd: _ref3,
    prefix: prefix,
    type: type
  };
  return (0, _core.jsx)(_Dropdown.default, rootProps, (0, _core.jsx)(_NavItem.default, triggerProps));
};

NavOverflowMenu.displayName = 'NavOverflowMenu';
var defaultProps = {
  itemAs: 'a'
};
NavOverflowMenu.defaultProps = defaultProps;
var _default = NavOverflowMenu;
exports.default = _default;